<template>
  <section>
    <loader v-if="!getSite" />
    <div class="about" v-else>
      <div class="about__section" v-html="getSite.aboutHTML"></div>
      <div class="about__section" v-if="showSocial">
        <div class="about__title">
          <h3>Social</h3>
        </div>
        <ul>
          <li v-for="link in getSite.contactLinks" :key="link.url">
            <span>{{link.name}} - </span>
            <a
              v-if="link.type === 'mailto'"
              target="_blank"
              :href="`mailto:${link.url}`"
            >
              {{link.label}}
            </a>
            <a
              v-else-if="link.type === 'href'"
              target="_blank"
              :href="link.url"
            >
              {{link.label}}
            </a>
            <span v-else>
              {{link.label}}
            </span>
          </li>
        </ul>
      </div>
      <div class="about__section">
        <div class="about__title">
          <h3>Join the JAND newsletter</h3>
          <h4>Keep up with new strips and announcements</h4>
        </div>
        <subscribe />
      </div>
      <div class="about__section" v-if="showPress">
        <div class="about__title">
          <h3>Press</h3>
        </div>
        <ul>
          <li v-for="link in getSite.pressLinks" :key="link.url">
            <a class="about__presslink" :href="link.url" target="_blank">
              <p>{{link.title}}</p>
              <span>{{link.publication}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';
import Subscribe from '@/views/Subscribe.vue';

export default {
  name: 'About',
  beforeCreate() {
    this.$store.dispatch('fetchSite');
  },
  components: {
    Loader,
    Subscribe,
  },
  computed: {
    ...mapGetters(['getSite']),
    options() {
      return this.getSite && this.getSite.options;
    },
    showPress() {
      return this.options && this.options.showPress;
    },
    showSocial() {
      return this.options && this.options.showSocial;
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  max-width: 600px;
  padding: 20px;
  margin: 0 auto;
  &__section {
    margin-bottom: 50px;
    @media all and (max-width: 700px) {
      margin-bottom: 30px;
    }
  }
  &__title {
    margin: 0 0 20px;
  }
  h3 {
    margin: 0;
    font-weight: 500;
  }
  h4 {
    margin: 0;
    font-weight: normal;
    color: var(--color-link-inactive);
  }
  &__presslink {
    display: block;
    margin-bottom: 20px;
    text-decoration: none;
    p {
      margin: 0 0 5px;
    }
    span {
      color: var(--color-link-inactive);
      display: block;
    }
    &:hover {
      border-color: var(--color-link);
      p {
        text-decoration: underline;
      }
    }
  }
}
</style>
